import { produce } from "immer";
import moment from "moment";
import {
  FETCH_TOOLS,
  FETCH_TOOLS_SUCCESS,
  FETCH_TOOLS_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  ADD_TOOLS,
  ADD_TOOLS_SUCCESS,
  ADD_TOOLS_FAILURE,
  //
  EDIT_TOOLS,
  EDIT_TOOLS_SUCCESS,
  EDIT_TOOLS_FAILURE,
  //
  DELETE_TOOLS,
  DELETE_TOOLS_SUCCESS,
  DELETE_TOOLS_FAILURE,
  //
  GET_RESIDENT_TOOL_DATA,
  GET_RESIDENT_TOOL_DATA_SUCCESS,
  GET_RESIDENT_TOOL_DATA_FAILURE,
  //
  SET_RESIDENT_TOOL_DATA_FILTERS,
  //
  UPDATE_TOOL_SEQUENCE,
  UPDATE_TOOL_SEQUENCE_SUCCESS,
  UPDATE_TOOL_SEQUENCE_FAILURE,
  //
  TOGGLE_TOOL_LOCATION_SETTING,
  TOGGLE_TOOL_LOCATION_SETTING_SUCCESS,
  TOGGLE_TOOL_LOCATION_SETTING_FAILURE,
  //
  SEARCH_TOOLS,
  SEARCH_TOOLS_SUCCESS,
  SEARCH_TOOLS_FAILURE,
  //
  GET_TOOL_SNAPSHOTS,
  GET_TOOL_SNAPSHOTS_SUCCESS,
  GET_TOOL_SNAPSHOTS_FAILURE,
} from "./constants";

// Get current week (Monday to Sunday)
const getCurrentWeekDates = () => {
  const startDate = moment().startOf("isoWeek").toDate(); // Monday
  const endDate = moment().endOf("isoWeek").toDate(); // Sunday
  return { startDate, endDate };
};

export const initialState = {
  isFetchingTools: false,
  tools: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentTool: {},
  // Delete
  isDeleting: false,
  // Get Resident Tool Data
  isFetchingResidentToolData: false,
  residentToolData: [],
  residentToolDataFilters: getCurrentWeekDates(),
  // Update Tool Sequence
  isUpdatingToolSequence: false,
  // Toggle Default Tool/Chart Location Setting
  isTogglingToolSetting: false,
  // Search Tools
  isSearchingTools: false,
  searchToolResults: [],
  // Get Tool Snapshots (paginated: { data, current_page, last_page, total, ... })
  isFetchingToolSnapshots: false,
  toolSnapshots: null,
};

const ResidentToolsReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_TOOLS:
        draft.isFetchingTools = true;
        draft.tools = [];
        break;
      case FETCH_TOOLS_SUCCESS:
        draft.isFetchingTools = false;
        draft.tools = action.payload;
        break;
      case FETCH_TOOLS_FAILURE:
        draft.tools = [];
        draft.isFetchingTools = false;
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentTool = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentTool = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_TOOLS:
        draft.isSubmitting = true;
        break;
      case ADD_TOOLS_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_TOOLS_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_TOOLS:
        draft.isSubmitting = true;
        break;
      case EDIT_TOOLS_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_TOOLS_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_TOOLS:
        draft.isDeleting = true;
        break;
      case DELETE_TOOLS_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_TOOLS_FAILURE:
        draft.isDeleting = false;
        break;
      // Get Resident Tool Data
      case GET_RESIDENT_TOOL_DATA:
        draft.isFetchingResidentToolData = true;
        draft.residentToolData = [];
        break;
      case GET_RESIDENT_TOOL_DATA_SUCCESS:
        draft.isFetchingResidentToolData = false;
        draft.residentToolData = action.payload;
        break;
      case GET_RESIDENT_TOOL_DATA_FAILURE:
        draft.isFetchingResidentToolData = false;
        draft.residentToolData = [];
        break;
      // Set Resident Tool Data Filters
      case SET_RESIDENT_TOOL_DATA_FILTERS:
        draft.residentToolDataFilters = action.payload;
        break;
      // Update Tool Sequence
      case UPDATE_TOOL_SEQUENCE:
        draft.isUpdatingToolSequence = true;
        break;
      case UPDATE_TOOL_SEQUENCE_SUCCESS:
        draft.isUpdatingToolSequence = false;
        break;
      case UPDATE_TOOL_SEQUENCE_FAILURE:
        draft.isUpdatingToolSequence = false;
        break;
      // Toggle Default Tool/Chart Location Setting
      case TOGGLE_TOOL_LOCATION_SETTING:
        draft.isTogglingToolSetting = true;
        break;
      case TOGGLE_TOOL_LOCATION_SETTING_SUCCESS:
        draft.isTogglingToolSetting = false;
        break;
      case TOGGLE_TOOL_LOCATION_SETTING_FAILURE:
        draft.isTogglingToolSetting = false;
        break;
      // Search Tools
      case SEARCH_TOOLS:
        draft.isSearchingTools = true;
        draft.searchToolResults = [];
        break;
      case SEARCH_TOOLS_SUCCESS:
        draft.isSearchingTools = false;
        draft.searchToolResults = action.payload;
        break;
      case SEARCH_TOOLS_FAILURE:
        draft.isSearchingTools = false;
        draft.searchToolResults = [];
        break;
      // Get Tool Snapshots (paginated; append when page > 1)
      case GET_TOOL_SNAPSHOTS:
        draft.isFetchingToolSnapshots = true;
        if (action.payload?.page === 1) {
          draft.toolSnapshots = null;
        }
        break;
      case GET_TOOL_SNAPSHOTS_SUCCESS: {
        draft.isFetchingToolSnapshots = false;
        const payload = action.payload;
        const currentPage = payload?.current_page ?? 1;
        if (currentPage === 1) {
          draft.toolSnapshots = payload;
        } else {
          const prevData = draft.toolSnapshots?.data ?? [];
          draft.toolSnapshots = {
            ...payload,
            data: [...prevData, ...(payload?.data ?? [])],
          };
        }
        break;
      }
      case GET_TOOL_SNAPSHOTS_FAILURE:
        draft.isFetchingToolSnapshots = false;
        // keep previous data on failure (e.g. load-more)
        if (!draft.toolSnapshots) draft.toolSnapshots = null;
        break;
      default:
        return state;
    }
  });

export default ResidentToolsReducer;
